import { render, staticRenderFns } from "./ItemLimiter.vue?vue&type=template&id=48dbd02a&"
import script from "./ItemLimiter.vue?vue&type=script&lang=ts&"
export * from "./ItemLimiter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports